var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"orders"}},[_c('b-header'),_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"cal"},domProps:{"innerHTML":_vm._s(_vm.calendar)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }